import React from 'react';
import { useTranslation } from 'react-i18next';

import { Icon, type CalloutProps } from '../../../../components';
import { Notice, DismissButton } from './DismissibleNotice.styles';

export type DismissibleNoticeProps = Omit<CalloutProps, 'action' | 'className'> & {
  /** Dismiss, for THIS visit only: callers hold the flag in local state and never persist it. A
   *  dismissal that outlived its condition would hide the only warning. */
  onDismiss: () => void;
  /** Drop Callout's tone glyph (for a banner that sits under a row already leading with an icon). */
  hideIcon?: boolean;
  className?: string;
};

/**
 * A Callout with a dismiss X in its action slot: the scenario's one banner shape (the create form's
 * price banner, the mailbox page's password notices). The X is the only addition; tone, icon, title
 * and text are Callout's own, so the banner keeps Callout's role for its tone. Pass `title` / `text`
 * as literals at the call site: the extractor harvests `text` attributes, and `title` values are
 * hand-kept in the catalogs.
 */
export const DismissibleNotice = ({
  onDismiss,
  hideIcon = false,
  ...callout
}: DismissibleNoticeProps): React.ReactElement => {
  const { t } = useTranslation();
  return (
    <Notice
      {...callout}
      $noIcon={hideIcon}
      action={
        <DismissButton type="button" aria-label={t('Dismiss')} onClick={onDismiss}>
          <Icon name="close" size={16} />
        </DismissButton>
      }
    />
  );
};

export default DismissibleNotice;
